export const MONTH_LABELS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const MONTH_ABBR = MONTH_LABELS.map((label) => label.slice(0, 3));

const MIN_AGE = 18;
const MAX_AGE = 100;

function isLeapYear(year: number) {
  return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
}

function daysInMonth(year: number, month: number) {
  if (month === 2) return isLeapYear(year) ? 29 : 28;
  if ([4, 6, 9, 11].includes(month)) return 30;
  return 31;
}

function maxAllowedDate() {
  const now = new Date();
  return new Date(now.getFullYear() - MIN_AGE, now.getMonth(), now.getDate());
}

function minAllowedDate() {
  const now = new Date();
  return new Date(now.getFullYear() - MAX_AGE, now.getMonth(), now.getDate());
}

export function formatDob(year: number, month: number, day: number) {
  return `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
}

export function parseDob(value: string) {
  if (!value) return null;

  const iso = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
  if (iso) {
    return {
      year: Number(iso[1]),
      month: Number(iso[2]),
      day: Number(iso[3]),
    };
  }

  const dmy = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(value);
  if (dmy) {
    return {
      day: Number(dmy[1]),
      month: Number(dmy[2]),
      year: Number(dmy[3]),
    };
  }

  return null;
}

export function getInitialDayOptions() {
  return Array.from({ length: 31 }, (_, i) => i + 1);
}

export function getAllowedMonthsForDay(day: number) {
  return Array.from({ length: 12 }, (_, i) => i + 1).filter((month) => {
    if (day <= 28) return true;
    if (day === 29) return true;
    if (day === 30) return month !== 2;
    return [1, 3, 5, 7, 8, 10, 12].includes(month);
  });
}

export function getAllowedYearsForDayMonth(day: number, month: number) {
  const minDate = minAllowedDate();
  const maxDate = maxAllowedDate();
  const years: number[] = [];

  for (let year = maxDate.getFullYear(); year >= minDate.getFullYear(); year -= 1) {
    if (day > daysInMonth(year, month)) continue;

    const candidate = new Date(year, month - 1, day);
    if (candidate > maxDate || candidate < minDate) continue;

    years.push(year);
  }

  return years;
}

export function isValidDobDate(value: string) {
  const parsed = parseDob(value);
  if (!parsed) return false;

  const { day, month, year } = parsed;
  if (day < 1 || month < 1 || month > 12 || year < 1) return false;
  if (day > daysInMonth(year, month)) return false;

  const date = new Date(year, month - 1, day);
  return date >= minAllowedDate() && date <= maxAllowedDate();
}
